import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeeTypesService, FeeTypeRequestDTO } from '../../../../services/fee-types.service';
import { ToastService } from "../../../../services/toast.service";
import { LoadingService } from "../../../../services/loading.service";

@Component({
  selector: 'app-new-fee-type',
  templateUrl: './new-fee-type.component.html',
  styleUrls: ['./new-fee-type.component.scss']
})
export class NewFeeTypeComponent implements OnInit {
  feeTypeForm!: FormGroup;
  isEditing = false;
  feeTypeId: string | null = null;
  submitting = false;

  constructor(
    private fb: FormBuilder,
    private feeTypesService: FeeTypesService,
    private toastService: ToastService,
    public router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.feeTypeId = this.route.snapshot.paramMap.get('id');
    if (this.feeTypeId) {
      this.isEditing = true;
      this.loadFeeType();
    }
  }

  private initForm(): void {
    this.feeTypeForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      description: ['', [Validators.maxLength(250)]]
    });
  }

  private loadFeeType(): void {
    this.loadingService.show();
    this.feeTypesService.getById(Number(this.feeTypeId)).subscribe({
      next: (response) => {
        this.feeTypeForm.patchValue(response.data);
        this.loadingService.hide();
      },
      error: () => {
        this.toastService.showToast('error', 'Error al cargar la información del tipo de comisión');
        this.loadingService.hide();
        this.router.navigate(['/config/fee-types']);
      }
    });
  }

  onSubmit(): void {
    if (this.feeTypeForm.invalid || this.submitting) {
      this.feeTypeForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.loadingService.show();

    const feeTypeData: FeeTypeRequestDTO = this.feeTypeForm.value;
    const request = this.isEditing
      ? this.feeTypesService.update(Number(this.feeTypeId), feeTypeData)
      : this.feeTypesService.insert(feeTypeData);

    request.subscribe({
      next: () => {
        this.toastService.showToast(
          'success',
          `Tipo de comisión ${this.isEditing ? 'actualizado' : 'creado'} exitosamente`
        );
        this.router.navigate(['/config/fee-types']);
      },
      error: () => {
        this.toastService.showToast(
          'error',
          `Error al ${this.isEditing ? 'actualizar' : 'crear'} el tipo de comisión`
        );
      },
      complete: () => {
        this.submitting = false;
        this.loadingService.hide();
      }
    });
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.feeTypeForm.get(controlName);
    return control?.touched && control?.hasError(errorType) || false;
  }
}
